var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"indicator",style:({
    'backgroundColor': _vm.color,
    'width': `${_vm.size}px`,
    'height': `${_vm.size}px`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }